/**
 * 관 미디어 콘텐츠 서비스
 */

import apiClient from './api';
import { HallMedia } from '../types/product';

export const hallMediaService = {
  /**
   * 관별 미디어 목록 조회
   */
  async getHallMedia(hallId: number): Promise<HallMedia[]> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { media: HallMedia[] } }>(`/admin/halls/${hallId}/media`);
    // return response.data.data.media;

    return [];
  },

  /**
   * 미디어 등록
   */
  async createHallMedia(hallId: number, data: Partial<HallMedia>): Promise<HallMedia> {
    // TODO: 백엔드 API 구현 후 연동
    // const formData = new FormData();
    // if (data.media_url) formData.append('media_url', data.media_url);
    // if (data.thumbnail_url) formData.append('thumbnail_url', data.thumbnail_url);
    // if (data.title) formData.append('title', data.title);
    // if (data.description) formData.append('description', data.description);
    // if (data.media_type) formData.append('media_type', data.media_type);
    // if (data.display_order !== undefined) formData.append('display_order', data.display_order.toString());
    // if (data.is_main !== undefined) formData.append('is_main', data.is_main.toString());
    // const response = await apiClient.post<{ data: { media: HallMedia } }>(`/admin/halls/${hallId}/media`, formData, {
    //   headers: { 'Content-Type': 'multipart/form-data' }
    // });
    // return response.data.data.media;

    throw new Error('Not implemented');
  },

  /**
   * 미디어 수정
   */
  async updateHallMedia(hallId: number, mediaId: number, data: Partial<HallMedia>): Promise<HallMedia> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { media: HallMedia } }>(`/admin/halls/${hallId}/media/${mediaId}`, data);
    // return response.data.data.media;

    throw new Error('Not implemented');
  },

  /**
   * 미디어 삭제
   */
  async deleteHallMedia(hallId: number, mediaId: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/halls/${hallId}/media/${mediaId}`);

    throw new Error('Not implemented');
  },
};

